import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _ConfigAdmin } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { CardTaps } from "../../../../theme/Component/CardTaps";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { CostingCenterSelect } from "../../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { EditorFunctionalAreaByEmployee } from "../FunctionalAreaByEmployee/EditorFunctionalAreaByEmployee";

interface Props {
    functionalIDLn: number;
}

export const FunctionalIDProperties = forwardRef(({ functionalIDLn }: Props, ref) => {

    const { lista, setLista, bean, setBean, handleChange, instance } = useDataBean(_ConfigAdmin)
    const [indexTap, setIndexTap] = useState(0);

    useEffect(() => {
        if (functionalIDLn) {
            if (indexTap === 0) {
                getProperties()
            } else if (indexTap === 1) {
                getUsers()
            }
        } else {
            toast.error("Algo salio mal")
        }
    }, [functionalIDLn, indexTap])

    const getProperties = () => {
        instance.getFunctionalIDProperties(functionalIDLn).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se Pudo cargar las Propiedades")
            }
        )
    }

    const getUsers = () => {
        instance.getFunctionalAreaByFunctionalID(functionalIDLn, null).then(
            (resp) => {
                
                setLista(resp);
            }
        ).catch(
            err => {
                
                toast.error("No se pudo cargar los usuarios")
            }
        )
    }

    const updateData = () => {
        instance.updateFunctionalIDProperties(bean).then(
            (resp) => {
                getProperties();
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo acutalizar los datos")
            }
        )
    }

    let taps = [
        { id: 0, name: 'Configuración', disable: false },
        { id: 1, name: 'Personal en el Área', disable: false }
    ];

    const head = [
        { title: 'ID', property: 'IDContract', visible: true ,mask:MASK_NUMBER},
        { title: 'Identificacion', property: 'Nit', visible: true,mask:MASK_NUMBER },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        { title: 'Grado', property: 'AppointmentName', visible: true },
        { title: 'Fecha Inicio', property: 'InitContract', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        
    ]

    useImperativeHandle(ref, () => ({
        updateData,
    }));

    return (
        <div className="row">
            <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                {indexTap === 0 &&
                    <>
                        <div className="row">
                            <div className="col-md-12"><hr /></div>
                            <div className="col-md-12">
                                <label className="form-label" style={{ color: "#fb8e00" }} >Configurar Jefe de Área</label>
                            </div>
                            <div className="col-md-12"><hr /></div>

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Utilizar Jefe del Area Funcional desde Planta de Personal</label>
                                        <BasicSwitch label=" " estado={bean.UseFunctionalAreaAsBoss ?? false} eventChange={(e) => { setBean({ ...bean, "UseFunctionalAreaAsBoss": e }) }} />
                                    </div>
                                    {!bean.UseFunctionalAreaAsBoss ?
                                        <div className="col-md-6">
                                            <AccountEditor label="Jefe de Área Funcional" idAccount={!bean.UseFunctionalAreaAsBoss ? bean.IDBoss : null} onChange={(e) => { setBean({ ...bean, "IDBoss": e.IDAccount }) }} />
                                        </div>
                                        :
                                        <div className="col-md-6">
                                            <EditorFunctionalAreaByEmployee Value={bean.UseFunctionalAreaAsBoss ? bean.IDBoss : null} onChange={(e) => {
                                                setBean({ ...bean, "IDBoss": e.IDLn });
                                            }} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12"><hr /></div>
                            <div className="col-md-12">
                                <label className="form-label" style={{ color: "#fb8e00" }} >Configurar Administrador de Personal</label>
                            </div>
                            <div className="col-md-12"><hr /></div>

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Utilizar Administrador de Personal desde Planta de Personal</label>
                                        <BasicSwitch label=" " estado={bean.UseFunctionalAreaAsHRAdmin ?? false} eventChange={(e) => { setBean({ ...bean, "UseFunctionalAreaAsHRAdmin": e }) }} />
                                    </div>
                                    {!bean.UseFunctionalAreaAsHRAdmin ?
                                        <div className="col-md-6">
                                            <AccountEditor label="Jefe de Área Funcional" idAccount={bean.UseFunctionalAreaAsHRAdmin ? bean.IDHRBoss : null} onChange={(e) => { setBean({ ...bean, "IDHRBoss": e.IDAccount }) }} />
                                        </div>
                                        :
                                        <div className="col-md-6">
                                            <EditorFunctionalAreaByEmployee Value={bean.UseFunctionalAreaAsHRAdmin ? bean.IDHRBoss : null} onChange={(e) => {
                                                setBean({ ...bean, "IDHRBoss": e.IDLn });
                                            }} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12"><hr /></div>
                            <div className="col-md-12">
                                <label className="form-label" style={{ color: "#fb8e00" }} >Modificar Centro de Costo</label>
                            </div>
                            <div className="col-md-12"><hr /></div>
                            <div className="col-md-12">
                                <CostingCenterSelect idSelector={bean.CostingCenter} onChange={(e) => { setBean({ ...bean, "CostingCenter": e }) }} />
                            </div>
                        </div>
                    </>
                }
                {indexTap === 1 &&
                    <div className="row">
                        <BasicTable key={lista} body={lista} head={head} rowSet={(e) => { console.log(e) }} />
                    </div>
                }
            </CardTaps>
            {/* <PrintJson json={bean} /> */}
        </div>
    )
});